import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: (signed: boolean) =>
        css({
            display: 'flex',
            flexDirection: 'column',
            padding: '20px',
            alignSelf: 'stretch',
            border: `1px solid ${signed ? theme.palette.success.dark : theme.palette.error.dark}`,
            ...(isHosTheme && {
                borderRadius: theme.custom.borderRadius[23],
                backgroundColor: theme.palette.common.white,
            }),
        }),

    wrapper: css({
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        alignSelf: 'stretch',
    }),

    text: css({
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        flex: '1 0 0',
    }),

    arrow: css({
        marginLeft: 'auto',
    }),
};
